import { ConfirmDialog } from '@/components/confirm-dialog'
import { useFilters } from '@/hooks/useFilters'
import { listAutomationsQuery } from '@/queries/automation.query'
import { AutomationService } from '@/services/automations.service'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useAutomations } from '../context/automations-context'
import { AutomationMutateDrawer } from './automation-mutate-drawer'
import { AutomationStatsDialog } from './automation-stats-dialog'

export function AutomationDialogs() {
  const { open, setOpen, currentRow, setCurrentRow } = useAutomations()
  const { filters } = useFilters('/_authenticated/automations/')
  const queryClient = useQueryClient()

  return (
    <>
      <AutomationMutateDrawer
        key='automation-create'
        open={open === 'create'}
        onOpenChange={() => setOpen('create')}
      />

      {currentRow && (
        <>
          <AutomationMutateDrawer
            key={`automation-update-${currentRow.id}`}
            open={open === 'update'}
            onOpenChange={() => {
              setOpen('update')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            currentRow={currentRow}
          />

          <AutomationStatsDialog
            key={`automation-stats-${currentRow.id}`}
            open={open === 'stats'}
            onOpenChange={() => {
              setOpen('stats')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            automation={currentRow}
          />

          <ConfirmDialog
            key='automation-delete'
            destructive
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            handleConfirm={() => {
              setOpen(null)
              setCurrentRow(null)
              toast.promise(AutomationService.delete(currentRow.id), {
                loading: 'Deletando automação...',
                success: async () => {
                  await queryClient.invalidateQueries(
                    listAutomationsQuery(filters)
                  )
                  return 'Automação deletada'
                },
                error: async () => {
                  await queryClient.invalidateQueries(
                    listAutomationsQuery(filters)
                  )
                  return 'Erro ao deletar automação!'
                },
              })
            }}
            className='max-w-md'
            title={`Deletar esta automação: ${currentRow.name} ?`}
            desc={
              <>
                Você está prestes a deletar a automação{' '}
                <strong>{currentRow.name}</strong>. <br />
                Esta ação não pode ser revertida.
              </>
            }
            confirmText='Deletar'
          />
        </>
      )}
    </>
  )
}
